module.exports = __webpack_public_path__ + "15b7a44a36ec749ea8ef6ed2bc738a42.jpg";